import React, { useState } from 'react';
import { Title } from '@gerdau/hefesto/Title';
import { Button, Select } from '@gerdau/hefesto';

import { Header } from '../styles';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { uppercaseOnlyFirstLetter } from '../../../utils/formatStrings';
import { ICustomer } from '../../../store/ducks/customers/types';
import { updateManifestationsSettings } from '../../../store/ducks/manifestations/actions';
import IsManagerCustomerInput from '../../../components/IsManagerCustomerInput';
import AdminBpInput from '../../../components/AdminBpInput';
import { GetFlag } from '../../../utils/featureFlag';

interface Props {
  onSearch: () => void;
}

export const ManifestationHeader = ({ onSearch }: Props) => {
  const dispatch = useDispatch();
  const manifestationsState = useSelector(
    (state: ApplicationState) => state.manifestations
  );

  const newSearchEmitterInputAdmin = GetFlag('new_search_emitter_input_admin');

  const [selectedCustomerId, setSelectedCustomerId] = useState(
    manifestationsState.selectedCustomerId ?? ''
  );

  const userState = useSelector((state: ApplicationState) => state.user);

  const purchaseCustomers = useSelector((state: ApplicationState) =>
    state.customers.customers.filter((customer) =>
      userState.roles.ordersInputCustomers.includes(customer.customerId)
    )
  );

  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const customerOptions = (customers: ICustomer[]) =>
    customers.map((customer) => {
      return {
        label: `${uppercaseOnlyFirstLetter(customer.name)}`,
        value: `${customer.customerId}`,
        descriptions: [
          `BP: ${customer.customerId}`,
          `CNPJ: ${customer.taxNumber}`,
          `${uppercaseOnlyFirstLetter(
            customer.locality.address
          )} | ${uppercaseOnlyFirstLetter(customer.locality.city)} - ${
            customer.locality.state
          } | CEP ${customer.locality.zipCode}`
        ]
      };
    });

  const getCustomer = (customerId: string): ICustomer => {
    return purchaseCustomers.find(
      (customer) => customer.customerId === customerId
    ) as ICustomer;
  };

  const onSelectCustomer = (customerId: string) => {
    const customer = getCustomer(customerId);
    if (customer) {
      dispatch(updateManifestationsSettings(customer.customerId));
      setSelectedCustomerId(customer.customerId);
      return customer;
    }
  };

  const loading = customersState.loading || manifestationsState.loading;

  const disabled = loading || !selectedCustomerId;

  return (
    <Header style={{ position: 'relative' }}>
      <Title level={1}>Manifestações</Title>
      <span className="subtitle">
        Selecione um emissor para acompanhar suas manifestações de aços longos e
        de aços planos.
      </span>

      <div
        style={{
          marginTop: '1.5rem',
          display: 'flex',
          alignItems: 'flex-end',
          gap: '1.5rem'
        }}
      >
        <div
          style={{
            width: '368px'
          }}
        >
          {userState.isManager ? (
            newSearchEmitterInputAdmin ? (
              <AdminBpInput
                title="Emissor"
                customerId={selectedCustomerId}
                setCustomerId={(e) => {
                  setSelectedCustomerId(e);
                  dispatch(updateManifestationsSettings(e));
                }}
                onChange={(e) => {
                  setSelectedCustomerId(e);
                  dispatch(updateManifestationsSettings(e));
                }}
                onSearch={onSearch}
                loading={loading}
                bpError={false}
              />
            ) : (
              <IsManagerCustomerInput
                title="Emissor"
                customerId={selectedCustomerId}
                setCustomerId={(e) => {
                  setSelectedCustomerId(e);
                  dispatch(updateManifestationsSettings(e));
                }}
                loading={loading}
                bpError={false}
              />
            )
          ) : (
            <Select
              label="Emissor"
              disabled={loading}
              name="emissorSelect"
              options={customerOptions(customersState.customers)}
              placeholder="Selecione um emissor"
              onSelect={(customerId) => onSelectCustomer(customerId as string)}
              value={selectedCustomerId}
            />
          )}
        </div>

        <Button
          style={{ minWidth: '172px', height: '48px' }}
          name="manifestation_search_button"
          disabled={disabled}
          loading={loading}
          onClick={onSearch}
        >
          Buscar
        </Button>
      </div>
    </Header>
  );
};
